	// Close the size calculator modal
	function closeSizeModal() {
		sizeModal.style.display = "none";
      fisrtModal.style.display = "none";
		
	}
	function closeSizeModal1() {
		
		bottomModal.style.display = "none";
	}
	
	
//top script start
function reenter(){

document.getElementById("bustSizeToggle").style.display = "table-row-group";
			document.getElementById("cupSizeToggle").style.display = "table-row-group";
			document.getElementById("cupSizeh").style.display = "block";
			document.getElementById("bustSizeh").style.display = "block";
			document.getElementById("reenter").style.display = "none";
			document.getElementById("calculateSize").style.display = "block";
document.getElementById("result").style.display = "none";

}
 document.getElementById("myButton").click();
 document.getElementById("myButton1").click();
	// Get the size calculator modal
	var sizeModal = document.getElementById("sizeModal");
var bottomModal = document.getElementById("bottomModal");
document.getElementById("reenter").style.display = "none";
	// Open the size calculator modal
	function openfisrtModal() {
		fisrtModal.style.display = "block";
	}
	function opentopModal() {
		sizeModal.style.display = "block";
		fisrtModal.style.display = "none";
		bottomModal.style.display = "none";
	}
	function openbottomModal() {
		bottomModal.style.display = "block";
		fisrtModal.style.display = "none";
		sizeModal.style.display = "none";
	}



	// Select a toggle button and deselect the others in the same group
	function selectToggle(toggleGroupId, selectedValue) {
		var buttons = document.getElementById(toggleGroupId).getElementsByTagName("button");
		for (var i = 0; i < buttons.length; i++) {
			if (buttons[i].innerHTML === selectedValue) {
				buttons[i].classList.add("selected");
			} else {
				buttons[i].classList.remove("selected");
			}
		}
	}

	// Calculate the bikini top size based on the selected bust and cup sizes
	function calculateSize() {
		var bustSize = getSelectedToggleValue("bustSizeToggle");
		var cupSize = getSelectedToggleValue("cupSizeToggle");
		if (bustSize && cupSize) {
			var sizes = {
				"73-78cm/ 28-30″": "XS",
				"78-84cm/ 30-33″": "S",
				"84-89CM/ 33-35″": "M",
				"89-94cm/ 35-37″": "L",
				"94-99cm/ 37-39″": "XL"
			};
			var size = sizes[bustSize];
			switch (cupSize) {
				case "AA":
					size += "";
					break;
				case "A":
					size += "";
					break;
				case "B":
					size += "";
					break;
				case "C":
					size += "";
					break;
				case "D":
					size += "";
					break;
				case "DD":
					size += "";
					break;
				case "E":
					size += "";
					break;
			}
			
			document.getElementById("result").innerHTML = "Your bikini top size is " + "<span style='font-size:60px'>"+size+"</span>";
		}
		document.getElementById("bustSizeToggle").style.display = "none";
			document.getElementById("cupSizeToggle").style.display = "none";
			document.getElementById("cupSizeh").style.display = "none";
			document.getElementById("bustSizeh").style.display = "none";
			document.getElementById("reenter").style.display = "block";
			document.getElementById("calculateSize").style.display = "none";
			document.getElementById("result").style.display = "block";
	}

	// Get the value of the selected toggle button in a toggle group
	function getSelectedToggleValue(toggleGroupId) {
		var buttons = document.getElementById(toggleGroupId).getElementsByTagName("button");
		for (var i = 0; i < buttons.length; i++) {
			if (buttons[i].classList.contains("selected")) {
				return buttons[i].innerHTML;
			}
		}
		return null;
	}
	//top script end
	
	
	
	
	
	
	//bottom script start
	
	
	
	
	
	
function reenter1(){

document.getElementById("bustSizeToggle1").style.display = "table-row-group";
			document.getElementById("cupSizeToggle1").style.display = "none";
			document.getElementById("cupSize1").style.display = "none";
			document.getElementById("bustSize1").style.display = "block";
			document.getElementById("reenter1").style.display = "none";
			document.getElementById("calculateSize1").style.display = "block";
document.getElementById("result1").style.display = "none";

}
	// Get the size calculator modal
	
document.getElementById("reenter1").style.display = "none";
	// Open the size calculator modal


	// Close the size calculator modal


	// Select a toggle button and deselect the others in the same group
	function selectToggle1(toggleGroupId1, selectedValue1) {
		var buttons = document.getElementById(toggleGroupId1).getElementsByTagName("button");
		for (var i = 0; i < buttons.length; i++) {
			if (buttons[i].innerHTML === selectedValue1) {
				buttons[i].classList.add("selected");
			} else {
				buttons[i].classList.remove("selected");
			}
		}
	}

	// Calculate the bikini top size based on the selected bust and cup sizes
	function calculateSize1() {
		var bustSize1 = getSelectedToggleValue1("bustSizeToggle1");
		var cupSize1 = getSelectedToggleValue1("cupSizeToggle1");
		if (bustSize1 && cupSize1) {
			var sizes = {
				"81-85cm/ 31.5-33.5″": "XS",
				"85-90cm/ 33.5-35.5″": "S",
				"90-95cm/ 35.5-37.5″": "M",
				"95-100cm/ 37.5-39.5″": "L",
				"100-105cm/ 39.5-41″": "XL"
			};
			var size = sizes[bustSize1];
			switch (cupSize1) {
				case "81-85cm/ 31.5-33.5″":
					size += "";
					break;
				case "85-90cm/ 33.5-35.5″":
					size += "";
					break;
				case "90-95cm/ 35.5-37.5″":
					size += "";
					break;
				case "95-100cm/ 37.5-39.5″":
					size += "";
					break;
				case "100-105cm/ 39.5-41″":
					size += "";
					break;
			
			}
			
			document.getElementById("result1").innerHTML = "Your bikini bottom size is " + "<span style='font-size:60px'>"+size+"</span>";
		}
			document.getElementById("bustSizeToggle1").style.display = "none";
			document.getElementById("cupSizeToggle1").style.display = "none";
			document.getElementById("cupSize1").style.display = "none";
			document.getElementById("bustSize1").style.display = "none";
			document.getElementById("reenter1").style.display = "block";
			document.getElementById("calculateSize1").style.display = "none";
			document.getElementById("result1").style.display = "block";
	}

	// Get the value of the selected toggle button in a toggle group
	function getSelectedToggleValue1(toggleGroupId1) {
		var buttons = document.getElementById(toggleGroupId1).getElementsByTagName("button");
		for (var i = 0; i < buttons.length; i++) {
			if (buttons[i].classList.contains("selected")) {
				return buttons[i].innerHTML;
			}
		}
		return null;
	}
	
	
	
	
	//bottom script end